<!-- <app-loader [is_show_loader]="!dataSource.data.length"></app-loader> -->
<div style="height: 20px; width: 100%"></div>
<div class="library-wrapper">
  <div class="library-container common-width">
    <h2>All Scenarios</h2>
    <div class="controls">
      <div class="scenario-input">
        <div
          style="
            width: 100%;
            align-items: center;
            grid-template-columns: 1fr 1fr;
            display: grid;
            height: calc(100%);
          "
        >
          <!-- <mat-form-field
            style="width: 270px"
            appearance="fill"
            class="planogram-search-input"
          > -->
          <div class="search-box">
            <mat-icon
              matPrefix
              style="height: 16px; width: 16px; padding: 5px; color: #e3e6eb"
              >search</mat-icon
            >
            <input
              style="border: none; width: 100%; padding-left: 10px"
              type="text"
              [ngModel]="searchQuery"
              (ngModelChange)="applySearch($event)"
              placeholder="Search for a base scenario by name"
            />
          </div>

          <!-- <i class="bi bi-funnel"></i> -->
          <!-- </mat-form-field> -->
        </div>
      </div>
      <div class="refresh" style="margin-top: 10px">
        <mat-icon (click)="refresh()"> refresh </mat-icon>
      </div>
      <div class="base-scenario">
        <button
          class="round-corners"
          (click)="redirectToCreateBase()"
          style="display: none"
          mat-raised-button
          color="warn"
        >
          <!-- *ngIf="userType === usreConfig.MANG" -->
          <img
            src="../../../assets/IMP PVP Tool Icons/create_scenario.svg"
            alt=""
          />
          <span> Create Base Scenario </span>
        </button>
      </div>
      <div class="compare-scenario">
        <button
          class="create-base-button"
          (click)="redirectToCreateBase()"
          color="primary"
          mat-raised-button
        >
          <!-- *ngIf="userType === usreConfig.MANG" -->
          <img
            src="../../../assets/IMP PVP Tool Icons/create_scenario.svg"
            alt=""
          />
          <span> Create Base Scenario </span>
        </button>
      </div>
    </div>
    <div
      style="width: 100%; height: 65vh; overflow: scroll; margin-top: 1.25rem"
    >
      <table
        style="width: 100%"
        mat-table
        [dataSource]="dataSource"
        matSort
        class="mat-elevation-z0 small-text-montserrat"
      >
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>
            <span [style.paddingLeft.px]="40"> Name </span>
          </th>
          <td mat-cell *matCellDef="let data" style="min-height: 52px">
            <button
              mat-icon-button
              [style.visibility]="!data.expandable ? 'hidden' : ''"
              [style.marginLeft.px]="data.level * 32"
              (click)="treeControl.toggle(data)"
            >
              <mat-icon
                (click)="removePreviouslySelectedChildIds()"
                *ngIf="treeControl.isExpanded(data)"
                class="mat-icon-rtl-mirror"
              >
                <!-- {{
                treeControl.isExpanded(data) ? "expand_more" : "chevron_right"
              }} -->
                expand_more
              </mat-icon>
              <mat-icon
                *ngIf="!treeControl.isExpanded(data)"
                class="mat-icon-rtl-mirror"
              >
                <!-- {{
                treeControl.isExpanded(data) ? "expand_more" : "chevron_right"
              }} -->
                chevron_right
              </mat-icon>
            </button>

            <!-- <mat-icon
            *ngIf="
              !childScenarioIds.includes(data.child_id) &&
              data.type != 'base' &&
              data.status == 1
            "
            style="color: red; position: relative; top: 7px"
            (click)="checkBoxChange(data)"
          >
            <span class="material-symbols-outlined">
              check_box_outline_blank
            </span>
          </mat-icon> -->

            <!-- <mat-icon
            *ngIf="
              childScenarioIds.includes(data.child_id) &&
              data.type != 'base' &&
              data.status == 1
            "
            style="color: red; position: relative; top: 7px"
            (click)="checkBoxChange(data)"
          >
            <span class="material-symbols-outlined"> check_box </span>
          </mat-icon> -->
            <div class="scenario_name">
              {{
                data.name.length > 18
                  ? data.name.slice(0, 18) + "..."
                  : data.name
              }}
              <div *ngIf="data.name.length > 18" class="scenario_on-hover">
                {{ data.name }}
              </div>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="volume">
          <th mat-header-cell *matHeaderCellDef>Volume</th>
          <td mat-cell *matCellDef="let data">
            {{ data.volume }}
          </td>
        </ng-container>

        <ng-container matColumnDef="month">
          <th mat-header-cell *matHeaderCellDef>Month</th>
          <td mat-cell *matCellDef="let data">
            {{ data.month }}
          </td>
        </ng-container>

        <ng-container matColumnDef="price">
          <th mat-header-cell *matHeaderCellDef>Price</th>
          <td mat-cell *matCellDef="let data">
            {{ data.price }}
          </td>
        </ng-container>

        <ng-container matColumnDef="channel">
          <th mat-header-cell *matHeaderCellDef>Channel</th>
          <td mat-cell *matCellDef="let data">
            {{ data.channel }}
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by">
          <th mat-header-cell *matHeaderCellDef>Created By</th>
          <td mat-cell *matCellDef="let data">
            {{ data.created_by }}
          </td>
        </ng-container>

        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>Created On</th>
          <td mat-cell *matCellDef="let data">
            {{ data.createdOn | date: "dd/MM/yyyy" }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let data">
            <div
              [ngClass]="{
                draft: data.status === 3,
                completed: data.status === 1,
                processing: data.status === 2,
                failed: data.status === 0
              }"
              class="common-status"
            >
              {{ status[data.status] }}
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="output">
          <th mat-header-cell *matHeaderCellDef>View Output</th>
          <td mat-cell *matCellDef="let data">
            <div
              [ngClass]="{
                disabled: data.status === 2
              }"
              class="action-group1"
            >
              <!-- <img
              *ngIf="data.type === 'child' && data.status != 0"
              class="pointer"
              matTooltip="Open Purple file Output"
              src="../../../assets/IMP PVP Tool Icons/purple.svg"
              alt=""
              (click)="openPurpleOutput(data.base_id, data)"
            /> -->
              <!-- {{ data | json }} -->
              <!-- [ngClass]="{
              disabled: data.status == 3
            }" -->
              <img
                *ngIf="data.type === 'child' && data.status != 0"
                class="pointer"
                [ngClass]="{
                  disabled: data.status == 3
                }"
                matTooltip="View Output Summary"
                src="../../../assets/IMP PVP Tool Icons/output-summary.svg"
                alt=""
                (click)="openOutputSummary(data.base_name, data)"
              />

              <!-- <img
              class="pointer"
              *ngIf="data.type === 'base'"
              (click)="extractChildDetails(data.base_id, data)"
              matTooltip="View Aggregate Summary"
              src="../../../assets/IMP PVP Tool Icons/agg-summary.svg"
              alt=""
            /> -->
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let data">
            <div class="action-group">
              <!-- <mat-icon
              matTooltip="Duplicate this child scenario"
              *ngIf="data.type === 'child' && data.status == 1"
              style="font-size: 19px; color: #e61a27; margin-top: 8px"
              (click)="
                duplicateChildScenario(
                  data.base_id,
                  data.name,
                  data.child_id,
                  data,
                  null,
                  data.type
                )
              "
            >
              content_copy
            </mat-icon> -->
              <img
                *ngIf="data.type === 'base'"
                style="margin-bottom: 5px"
                matTooltip="Add New Child Scenario"
                (click)="createNewChildScenario(data.base_id, data.name)"
                src="../../../assets/IMP PVP Tool Icons/Plus.svg"
                alt=""
                class="pointer"
              />

              <!-- <img
              *ngIf="
                data.status != 1 && data.status != 2 && data.type != 'base'
              "
              class="pointer"
              matTooltip="Edit Scenario"
              (click)="
                openChildScenario(
                  data.base_id,
                  data.name,
                  data.child_id,
                  data,
                  null,
                  data.type
                )
              "
              [ngClass]="{
                disabled: disabled
              }"
              src="../../../assets/IMP PVP Tool Icons/edit.svg"
              alt=""
            /> -->
              <img
                *ngIf="data.type !== 'base'"
                (click)="deleteChild($event, data)"
                matTooltip="Delete Scenario"
                [ngClass]="{
                  disabled: data.status === 2
                }"
                class="pointer"
                src="../../../assets/IMP PVP Tool Icons/delete.svg"
                alt=""
              />
              <img
                *ngIf="data.type === 'base'"
                (click)="deletePlan($event, data)"
                matTooltip="Delete Scenario"
                [ngClass]="{
                  disabled: data.status === 2
                }"
                class="pointer"
                src="../../../assets/IMP PVP Tool Icons/delete.svg"
                alt=""
              />
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <!-- <mat-card
      *ngIf="showLoader"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        height: 300px;
        flex-direction: column;
      "
    >
      <mat-progress-spinner color="warn" mode="indeterminate">
      </mat-progress-spinner>
      <h4 style="font-weight: bold; margin-top: 10px">Loading...</h4>
    </mat-card> -->
    <!-- <ng-container *ngIf="hidePagination && !searchQuery.length">
      <mat-paginator
        (page)="paginationChange($event)"
        #paginator
        [hidden]="dataSource.data.length === 0"
        [pageSize]="limit / 2"
        hidePageSize="true"
        showFirstLastButtons="false"
        [length]="scenarioCount"
      >
      </mat-paginator>
    </ng-container>
    <ng-container *ngIf="hidePagination && searchQuery.length">
      <mat-paginator
        (page)="paginationChange($event)"
        #paginator
        [hidden]="dataSource.data.length === 0"
        [pageSize]="scenarioCount"
        hidePageSize="true"
        showFirstLastButtons="false"
        [length]="scenarioCount"
      >
      </mat-paginator>
    </ng-container> -->
  </div>
</div>
